import {createSlice} from '@reduxjs/toolkit';
import {RootState} from './Store';

const initialState = {
  threadId: '',
  messagesList: [] as any[],
  messageListDWD: [] as any[],
  queryAnalyser: [],
  sessionContext: [],
  orchContext: [],
  threadId1: '',
  threadId2: '',
  convoId: null,
};

export const ChatBotSlice = createSlice({
  name: 'chatBot',
  initialState,
  reducers: {
    setThreadId: (state, action) => {
      state.threadId = action.payload;
    },
    setmessageList: (state, action) => {
      state.messagesList = action.payload;
    },
    setmessageListDWD: (state, action) => {
      state.messageListDWD = action.payload;
    },
    addIntermediateStep: (state, action) => {
      const {requestId, message} = action.payload;
      const messageIndex = state.messageListDWD.findIndex(
        (msg) => msg?.request_id === requestId,
      );
      if (messageIndex !== -1) {
        const originalMessage = state.messageListDWD[messageIndex];
        // Create a new array with the old steps and the new one
        const updatedIntermediateSteps = [
          ...originalMessage.intermediateSteps, // Spread all existing steps
          ...message, // Add the new steps array
        ];
        state.messageListDWD[messageIndex] = {
          ...originalMessage,
          intermediateSteps: updatedIntermediateSteps,
        };
      }
    },
    updateMessageListDWD(state, action) {
      const {requestId, finalBotMessage} = action.payload;
      const messageIndex = state.messageListDWD.findIndex(
        (msg) => msg?.request_id === requestId,
      );

      if (messageIndex !== -1) {
        // Update the existing placeholder message with the new data
        state.messageListDWD[messageIndex] = {
          ...state.messageListDWD[messageIndex],
          ...finalBotMessage,
          isLoading: false, // Ensure loading is set to false
        };
      }
    },
    setFeedback: (state, action) => {
      const {request_id, is_liked, is_disliked} = action.payload;
      state.messageListDWD = state.messageListDWD.map((msg: any) => {
        if (msg?.request_id === request_id) {
          return {
            ...msg,
            is_liked: is_liked ? true : null,
            is_disliked: is_disliked ? true : null,
          };
        }
        return msg;
      });
    },
    setqueryAnalyserDWD: (state, action) => {
      if (action.payload?.length > 5) {
        state.queryAnalyser = action.payload?.slice(1);
      } else {
        state.queryAnalyser = action.payload;
      }
    },
    setSessionContextDWD: (state, action) => {
      if (action.payload?.length > 5) {
        state.sessionContext = action.payload?.slice(1);
      } else {
        state.sessionContext = action.payload;
      }
    },
    setOrchContextDWD: (state, action) => {
      if (action.payload?.length > 5) {
        state.orchContext = action.payload?.slice(1);
      } else {
        state.orchContext = action.payload;
      }
    },
    setThreadIdDWD1: (state, action) => {
      state.threadId1 = action.payload;
    },
    setThreadIdDWD2: (state, action) => {
      state.threadId2 = action.payload;
    },
    setConvoId: (state, action) => {
      state.convoId = action.payload;
    },

    clearChatSlice: (state) => {
      state.threadId = '';
      state.messagesList = [];
      state.messageListDWD = [];
      state.queryAnalyser = [];
      state.sessionContext = [];
      state.orchContext = [];
      state.threadId1 = '';
      state.threadId2 = '';
      state.convoId = null;
    },
  },
});

export const {
  setThreadId,
  setmessageList,
  setmessageListDWD,
  setSessionContextDWD,
  setqueryAnalyserDWD,
  setThreadIdDWD1,
  setThreadIdDWD2,
  clearChatSlice,
  setFeedback,
  updateMessageListDWD,
  addIntermediateStep,
  setOrchContextDWD,
  setConvoId,
} = ChatBotSlice.actions;

export const getThreadId = (state: RootState) => state.chatSlice.threadId;

export const getmessageList = (state: RootState) =>
  state.chatSlice.messagesList;

export const getmessageListDWD = (state: RootState) =>
  state.chatSlice.messageListDWD;

export const getsessionContextDWD = (state: RootState) =>
  state.chatSlice.sessionContext;

export const getQueryAnalyserDWD = (state: RootState) =>
  state.chatSlice.queryAnalyser;

export const getOrchContextDWD = (state: RootState) =>
  state.chatSlice.orchContext;

export const getThreadId1 = (state: RootState) => state.chatSlice.threadId1;
export const getThreadId2 = (state: RootState) => state.chatSlice.threadId2;

export const getConvoId = (state: RootState) => state.chatSlice.convoId;

export default ChatBotSlice.reducer;
